import {
  IProject,
  IStaffInfo,
  ITaskLog,
  IUser,
  IUserProfile,
} from "@/interfaces";
import { MainState, AppNotification } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const NotifyContent = {
  save: "正在保存...",
  delete: "正在删除...",
  saveSuccess: "保存成功",
  deleteSuccess: "删除成功",
};

export const mutations = {
  setToken(state: MainState, payload: string) {
    state.token = payload;
  },
  setLoggedIn(state: MainState, payload: boolean) {
    state.isLoggedIn = payload;
  },
  setLoggedInUser(state: MainState, payload: any) {
    state.isLoggedInUser = payload;
  },
  setLogInError(state: MainState, payload: boolean) {
    state.logInError = payload;
  },
  setUsers(state: MainState, payload: IUser[]) {
    state.userList = payload;
  },
  setUserProfile(state: MainState, payload: IUserProfile) {
    state.userProfile = payload;
  },
  addNotification(state: MainState, payload: AppNotification) {
    state.notifications.push(payload);
  },
  removeNotification(state: MainState, payload: AppNotification) {
    state.notifications = state.notifications.filter(
      (notification) => notification !== payload
    );
  },
  setMyLastProject(state: MainState, payload: number) {
    state.myLastProject = payload;
  },
  setRefreshControl(state: MainState, payload: any) {
    state.refreshControl = payload;
  },
  setAllIndexes(state: MainState, payload: string[] | []) {
    state.allIndexes = payload;
  },
  setMobaProjects(state: MainState, payload: number[]) {
    state.mobaProjects = payload;
  },
  setHeroSkin(state: MainState, payload: any) {
    state.hero_skin = payload;
  },
  setSetTaskLogs(state: MainState, payload: ITaskLog[]) {
    state.taskLogs = payload;
  },
  setStaffInfo(state: MainState, payload: IStaffInfo) {
    state.staff_info = payload;
  },
};

const { commit } = getStoreAccessors<MainState | any, State>("");

export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLoggedInUser = commit(mutations.setLoggedInUser);
export const commitSetLogInError = commit(mutations.setLogInError);
export const commitSetToken = commit(mutations.setToken);
export const commitSetUsers = commit(mutations.setUsers);
export const commitSetUserProfile = commit(mutations.setUserProfile);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
export const commitSetMyLastProject = commit(mutations.setMyLastProject);
export const commitSetRefreshControl = commit(mutations.setRefreshControl);
export const commitSetAllIndexes = commit(mutations.setAllIndexes);
export const commitSetMobaProjects = commit(mutations.setMobaProjects);
export const commitSetHeroSkin = commit(mutations.setHeroSkin);
export const commitSetTaskLogs = commit(mutations.setSetTaskLogs);
export const commitSetStaffInfo = commit(mutations.setStaffInfo);
